import { Link } from "react-router-dom";
import { Gauge, MapPin, Mail, Phone, Instagram } from "lucide-react";
import { COMPANY, WHATSAPP_DISPLAY } from "@/lib/config";

const SEO_TAGS = [
    "Chiptuning Wien",
    "Softwareoptimierung Wien",
    "Stage 1 Wien",
    "Stage 2 Wien",
    "BMW Chiptuning",
    "Audi Chiptuning",
    "Mercedes Chiptuning",
    "VW Chiptuning",
    "DSG Optimierung",
    "Eco Tuning",
    "Leistungssteigerung Österreich",
];

export const Footer = () => {
    return (
        <footer data-testid="main-footer" className="relative border-t border-border bg-[#0A0A0A]">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
                <div className="grid gap-10 md:grid-cols-4">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-2.5">
                            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary">
                                <Gauge className="h-5 w-5 text-white" />
                            </div>
                            <div className="leading-none">
                                <div className="font-heading text-lg font-extrabold text-white">NA PERFORMANCE</div>
                                <div className="text-[10px] tracking-[0.25em] uppercase text-primary font-semibold">
                                    PerformanceOS
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 max-w-md text-sm leading-relaxed text-[#A1A1AA]">
                            Dein digitaler AI Performance Advisor. Lade deinen Zulassungsschein hoch und
                            erhalte in Sekunden eine KI-gestützte Analyse mit realistischen
                            Optimierungsmöglichkeiten – professionell, transparent und seriös.
                        </p>
                        <div className="mt-6 space-y-2 text-sm text-[#A1A1AA]">
                            <div className="flex items-center gap-2">
                                <MapPin className="h-4 w-4 text-primary" /> {COMPANY.street}, {COMPANY.zip_city}
                            </div>
                            <div className="flex items-center gap-2">
                                <Phone className="h-4 w-4 text-primary" /> {WHATSAPP_DISPLAY}
                            </div>
                            <div className="flex items-center gap-2">
                                <Mail className="h-4 w-4 text-primary" /> {COMPANY.email}
                            </div>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-sm font-semibold text-white">Navigation</h4>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            <li><a href="/#ablauf" className="text-[#A1A1AA] hover:text-white transition-colors">Ablauf</a></li>
                            <li><a href="/#produkte" className="text-[#A1A1AA] hover:text-white transition-colors">Produkte</a></li>
                            <li><a href="/#referenzen" className="text-[#A1A1AA] hover:text-white transition-colors">Referenzen</a></li>
                            <li><Link to="/analyse" className="text-[#A1A1AA] hover:text-white transition-colors">Analyse starten</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-sm font-semibold text-white">Leistungen</h4>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            <li className="text-[#A1A1AA]">Stage 1 &amp; Stage 2</li>
                            <li className="text-[#A1A1AA]">DSG Optimierung</li>
                            <li className="text-[#A1A1AA]">Eco Tuning</li>
                            <li className="text-[#A1A1AA]">Pops &amp; Bangs</li>
                            <li className="text-[#A1A1AA]">VMAX Aufhebung</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 border-t border-border pt-8">
                    <div className="flex flex-wrap gap-2">
                        {SEO_TAGS.map((t) => (
                            <span
                                key={t}
                                className="rounded-full border border-border px-3 py-1 text-xs text-[#52525B]"
                            >
                                {t}
                            </span>
                        ))}
                    </div>
                    <p className="mt-8 text-xs text-[#52525B]">
                        © {new Date().getFullYear()} {COMPANY.name} · PerformanceOS. Alle Leistungsangaben
                        sind Richtwerte und fahrzeugabhängig. Optimierungen nur, wo gesetzlich zulässig.
                    </p>
                    <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-[#52525B]">
                        <a
                            data-testid="footer-madeby-link"
                            href="https://cloudservice.hr"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-white transition-colors"
                        >
                            made by cloudservice.hr
                        </a>
                        <a
                            data-testid="footer-cloudservice-instagram"
                            href="https://instagram.com/cloudservice.hr"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="cloudservice.hr auf Instagram"
                            className="inline-flex items-center gap-1.5 hover:text-white transition-colors"
                        >
                            <Instagram className="h-3.5 w-3.5" /> cloudservice.hr
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
